import { createSelector } from "reselect";

export const selectEcoSettings = state => state.ecoSettings || [];

export const selectEvacuationSettings = createSelector(
	[selectEcoSettings],
	ecoSettings => ecoSettings.find(setting => setting?.key === "evacuation-accountability")?.value || {}
);

const getAccountedRaw = state => state.evacuationAccountability.accounted || [];
const getUnaccountedRaw = state => state.evacuationAccountability.unaccounted || [];

const sortByBadgeTimeDesc = list =>
	[...list].sort((a, b) => new Date(b.badgeReadTimestamp) - new Date(a.badgeReadTimestamp));

export const getSortedAccounted = createSelector([getAccountedRaw], accounted => sortByBadgeTimeDesc(accounted));

export const getSortedUnaccounted = createSelector([getUnaccountedRaw], unaccounted =>
	sortByBadgeTimeDesc(unaccounted)
);
